import { cn } from "@/lib/cn";

export type FullPageLoaderSpinnerProps = {
  className?: string;
};

const segments = Array.from({ length: 12 }, (_, index) => index);

export function FullPageLoaderSpinner({ className }: FullPageLoaderSpinnerProps) {
  return (
    <span className={cn("bfrs-relative bfrs-mb-7 bfrs-block bfrs-size-14 bfrs-select-none", className)} aria-hidden="true">
      {segments.map((segment) => (
        <span
          key={segment}
          className="bfrs-absolute bfrs-left-1/2 bfrs-top-0 bfrs-h-[10px] bfrs-w-[5px] bfrs-origin-[50%_28px] -bfrs-translate-x-1/2 bfrs-rounded-pill bfrs-bg-primary-bright bfrs-opacity-20 bfrs-animate-loader-segment"
          style={{
            transform: `translateX(-50%) rotate(${segment * 30}deg)`,
            animationDelay: `${segment * -80}ms`
          }}
        />
      ))}
    </span>
  );
}
